const TrashIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      {...props}
    >
      <path
        d="M1.89999 3.15005L13.1 3.15005M10.3 12.95H4.69999C3.9268 12.95 3.29999 12.3232 3.29999 11.55V3.85005C3.29999 3.46345 3.61339 3.15005 3.99999 3.15005H11C11.3866 3.15005 11.7 3.46345 11.7 3.85005V11.5501C11.7 12.3232 11.0732 12.95 10.3 12.95ZM6.09999 3.15005H8.89999C9.28659 3.15005 9.59999 2.83665 9.59999 2.45005V1.75005C9.59999 1.36345 9.28659 1.05005 8.89999 1.05005H6.09999C5.71339 1.05005 5.39999 1.36345 5.39999 1.75005V2.45005C5.39999 2.83665 5.71339 3.15005 6.09999 3.15005Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TrashIcon;
